//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { RepeatDetailsItem } from './RepeatDetailsItem';
import { TaxInputItem } from './TaxInputItem';
import { TransactionUpdateItem } from './TransactionUpdateItem';

export class ChargeOrDiscountTransactionUpdateItem extends TransactionUpdateItem {
    EventCategoryID: string | null = null;
    UpdateFutureTransactions: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;
    Taxes: TaxInputItem[] = [];

    constructor(initializer?: Partial<ChargeOrDiscountTransactionUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ChargeOrDiscountTransactionUpdateItem";
}
